import * as React from 'react';
import { useTranslation } from 'react-i18next';

import TH from '../../components/table/TH/TH';
import THead from '../../components/table/THead/THead';
import TR from '../../components/table/TR/TR';

import Icon from '../../components/icon/Icon';
import InteractiveElement from '../../components/interactive-element/InteractiveElement';
import { ProjectSortTypes } from '../../core/enums/ProjectSortTypes';

interface Props {
  sortFilter: ProjectSortTypes;
  isSortAscending: boolean;
  handleSorting: (type: ProjectSortTypes) => void;
}

const ProjectListingHeader: React.FC<Props> = ({ sortFilter, isSortAscending, handleSorting }) => {
  const { t } = useTranslation();

  const getHeadingIconClass = (type: ProjectSortTypes) => {
    return `project-listing__header-icon ${type === sortFilter && !isSortAscending ? 'project-listing__header-icon--desc' : ''} ${
      type === sortFilter ? 'project-listing__header-icon--active' : ''
    }`;
  };

  const getHeadingTextClass = (type: ProjectSortTypes) => {
    return `project-listing__header-title ${sortFilter === type ? 'project-listing__header-title--active' : ''}`;
  };

  return (
    <THead>
      <TR>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting(ProjectSortTypes.Name)} isDiv>
            <span className={getHeadingTextClass(ProjectSortTypes.Name)}>{t('common.projectName')}</span>
            <Icon className={getHeadingIconClass(ProjectSortTypes.Name)} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting(ProjectSortTypes.ProjectNumber)} isDiv>
            <span className={getHeadingTextClass(ProjectSortTypes.ProjectNumber)}>{t('common.projectNumber')}</span>
            <Icon className={getHeadingIconClass(ProjectSortTypes.ProjectNumber)} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting(ProjectSortTypes.ConstructionArea)} isDiv>
            <span className={getHeadingTextClass(ProjectSortTypes.ConstructionArea)}>{t('common.constructionArea')}</span>
            <Icon className={getHeadingIconClass(ProjectSortTypes.ConstructionArea)} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
        <TH>
          <InteractiveElement className="d-flex align-items-center" onClick={() => handleSorting(ProjectSortTypes.LastBooking)} isDiv>
            <span className={getHeadingTextClass(ProjectSortTypes.LastBooking)}>{t('projectListing.columns.lastBooking')}</span>
            <Icon className={getHeadingIconClass(ProjectSortTypes.LastBooking)} icon="arrow" svg size="extra-small" />
          </InteractiveElement>
        </TH>
      </TR>
    </THead>
  );
};

export default ProjectListingHeader;
